import {createReducer} from '@reduxjs/toolkit';
import {
    clearAttributesFilters,
    setAllAttributesFilters,
    setAttributesFilter,
} from 'src/modules/attributes/services/filters/actions';
import {Filters} from 'src/modules/attributes/typedefs';

type State = {
    data: Filters,
};

export const defaultState: State = {
    data: {
        name: [],
        fieldTypes: [],
        eventCodes: [],
    },
};

export const attributesFilters = createReducer<State>(defaultState, builder => builder
    .addCase(setAttributesFilter, (state, action) => {
        state.data = {
            ...state.data,
            [action.payload.filterType]: action.payload.filterValue,
        };
    })
    .addCase(clearAttributesFilters, state => {
        state.data = defaultState.data;
    })
    .addCase(setAllAttributesFilters, (state, action) => {
        state.data = action.payload;
    }),
);
